
import { Component, OnInit, Output, EventEmitter, ViewChild, Input } from '@angular/core';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { SwModalframeComponent } from 'src/app/librarys/components/basic-components/sw-modal-frame/sw-modal-frame.component';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { environment } from 'src/environments/environment';
declare var $: any;


@Component({
  selector: 'select-product',
  templateUrl: './select-product.component.html',
  styleUrls: ['./select-product.component.css']
})
export class SelectProductComponent implements OnInit {
  @ViewChild('modal') modal: SwModalframeComponent; //弹出层组件
  productList:any=[]; 
  constructor(
    private box: SwMassageBoxService,  //消息提示服务
    private _http: SwHttpClientService,
  ) { }

  @Input() param: any;
  @Output() callback = new EventEmitter(); //抛出事件
  ngOnInit() {
    this.productList=JSON.parse(this.param["productList"]);
  }
  //提交保存
  submit(status){
    let prodCodes="";
    if($("#productBox input[type='checkbox']:Checked").length==0){
      this.box.danger("请至少选择一个产品再操作");
      return false;
    }
    for(let i=0;i<$("#productBox input[type='checkbox']:Checked").length;i++){
      prodCodes+=$("#productBox input[type='checkbox']:Checked").eq(i).attr("id")+",";
    }
    prodCodes=prodCodes.substring(0, prodCodes.length - 1);  
    this._http.Post(environment.seekerWebAPI + "common/reinit"+"?operation="+status+"&prodCodes="+prodCodes,{}).subscribe(data=>{
        if(data.code==200){
          this.box.success("操作成功");
           //关闭模态框
           this.modal.toggle();
        }
    })
  }
}
